<template>
  <qx-custom-form
    :noSubBtn="true"
    ref="baseForm"
    :formData="baseForm"
    labelWidth="120px"
  >
    <span slot="paymentWayTip" style="margin-left: 16px" slot-scope="prop">
      <span class="error" v-if="prop.form.paymentWay === 2"
        >现金部分的费用会生成车辆费用申请</span
      >
    </span>
  </qx-custom-form>
</template>

<script>
import {
  oilList,
} from 'api/service';
export default {
  props: {
    initData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    initData: {
      immediate: true,
      handler (newValue) {
        this.$nextTick(() => {
          newValue.id = newValue.id || 0;
          newValue.state = newValue.state || 0;
          newValue.stateName = newValue.stateName || '';
          newValue.paymentWay = newValue.paymentWay ? Number(newValue.paymentWay) : 1;
          newValue.cardNoSelect = newValue.cardNoSelect ? String(newValue.cardNoSelect) : '';
          newValue.file = newValue.file || [];
          this.otherFormData = newValue;
          this.$refs.baseForm.setVal(newValue);
        });
      },
    },
  },
  data () {
    return {
      otherFormData: {},
      baseForm: {
        // cardNoSelectOptions: [ // 使用卡号
        //   ...this.cardNoSelectOptions,
        //   {
        //     label: '其他',
        //     value: 0,
        //   },
        // ],
        cardNoSelectOptions: [],
        form: [
          {
            label: 'id',
            value: 'id',
            type: 'input',
            disabled: false,
            hide: true,
            // default: this.initData.id || 0,
          },
          {
            label: '上报状态',
            value: 'state',
            type: 'input',
            disabled: false,
            hide: true,
            // default: this.initData.state || 0,
          },
          {
            label: '上报状态名',
            value: 'stateName',
            type: 'input',
            disabled: false,
            hide: true,
            // default: this.initData.stateName || '',
          },
          {
            label: '消费金额',
            value: 'amount',
            type: 'input',
            disabled: false,
            // default: this.initData.amount,
          },
          {
            label: '加油升数',
            value: 'oilRise',
            type: 'input',
            disabled: false,
            // default: this.initData.oilRise,
          },
          {
            label: '支付方式',
            value: 'paymentWay',
            type: 'select',
            disabled: false,
            // default: this.initData.paymentWay ? Number(this.initData.paymentWay) : 1,
            onChange: () => {
              this.handlePaymentWayChange();
            },
            options: [
              {
                label: '油卡',
                value: 1,
              },
              {
                label: '现金',
                value: 2,
              },
            ],
          },
          {
            label: '油站名称',
            value: 'oilProductName',
            type: 'input',
            hide: true,
            disabled: false,
            // default: this.initData.oilProductName,
          },
          {
            label: '使用卡号',
            value: 'cardNoSelect',
            type: 'select',
            hide: false,
            disabled: false,
            // default: this.initData.cardNoSelect ? String(this.initData.cardNoSelect) : '',
            onChange: () => {
              this.handleCardNoSelectChange();
            },
          },
          // {
          //   label: '卡号',
          //   value: 'cardNo',
          //   type: 'input',
          //   hide: true,
          // },
          {
            label: '卡号',
            value: 'cardNo',
            type: 'el-autocomplete',
            valueKey: 'oilCarNum',
            disabled: false,
            hide: true,
            querySearchAsync: (queryString, cb) => {
              let result = [];
              if (queryString && queryString.length) {
                oilList({ oilCarNum: queryString }).then((res) => {
                  if (res && res.items) {
                    result = res.items;
                  }
                  cb(result);
                });
              }
              cb(result);
            },
          },
          {
            label: '上传附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            disabled: false,
            attr: {
              limit: 3,
            },
            // default: this.initData.file || [],
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            disabled: false,
            attr: {
              type: 'textarea',
            },
            // default: this.initData.remark,
          },
        ],
        rules: {
          amount: [ // 消费金额
            { required: true, message: '请输入消费金额', trigger: 'blur' },
          ],
          oilRise: [ // 加油升数
            { required: true, message: '请输入加油升数', trigger: 'blur' },
          ],
          paymentWay: [ // 支付方式
            { required: true, message: '请选择支付方式', trigger: 'blur' },
          ],
          file: [ // 上传附件
            { required: true, message: '请选择上传附件', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handlePaymentWayChange () {
      const paymentWay = this.$refs.baseForm.getVal('paymentWay');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: paymentWay !== 1,
        names: ['cardNoSelect', 'cardNo'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: paymentWay !== 4,
        names: ['oilProductName'],
      });
      this.$emit('handlePaymentWayChange', paymentWay);
    },
    handleCardNoSelectChange () {
      const cardNoSelect = this.$refs.baseForm.getVal('cardNoSelect');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: cardNoSelect !== 0,
        names: ['cardNo'],
      });
    },
    setDisabledByState (disabled) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: disabled,
      });
    },
    setRequiredByState (required) {
      this.setFormRuleAttr({
        rules: this.baseForm.rules,
        attr: 'required',
        value: required,
      });
    },
    mounted () {
      this.handlePaymentWayChange();
      this.handleCardNoSelectChange();
    },
    async getVal () {
      const res = await this.$refs.baseForm.getVal();
      if (res.cardNoSelect) {
        res.cardNo = res.cardNoSelect;
      } else {
        if (res.cardNo) {
          res.cardNoSelect = 0;
        }
      }
      const formData = {
        ...this.otherFormData,
        ...res,
      };
      return formData;
    },
    async sub () {
      const res = await this.$refs.baseForm.sub();
      if (res) {
        if (res.cardNoSelect) {
          res.cardNo = res.cardNoSelect;
        } else {
          res.cardNoSelect = res.cardNo;
        }
      }
      const formData = {
        ...this.otherFormData,
        ...res,
      };
      return formData;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
